import { Timestamp } from 'firebase/firestore';
import moment from 'moment';

const ChatItem = ({ chat, isSelected, onClick, index, isHighlighted }) => { 
  const lastMessage = chat.lastMessage ?? chat.messages?.[chat.messages?.length - 1];
  const lastMessageText = lastMessage?.text || '';
  const lastMessageTime = lastMessage?.timestamp
    ? moment(lastMessage.timestamp).fromNow()
    : moment( chat.createdAt instanceof Timestamp ? chat.createdAt.toDate() : chat.createdAt).fromNow();
  const isReadedLastMessage = lastMessage?.readed;

  return (
    <div
      style={{
        backgroundColor: isSelected ? '#FF8E04' : '#323232',
      }}
      className={`chat-item${isHighlighted ? ' highlight' : ''}`}
      onClick={onClick}
    >
      <img
        src={chat?.client?.avatar || `https://picsum.photos/seed/${index}/100/100`}
        className='avatar'
        alt={`${chat.client.name} аватар`}
      />
      <div className='chat-info'>
        <div className='chat-title'>{chat.client.name}</div>
        <div
          className='chat-last-message'
          style={{ color: isSelected ? '#FFFDFE' : '#B1B1B1' }}
        >
          {lastMessageText}
        </div>
      </div>
      <div
        className='chat-time'
        style={{ color: isSelected ? '#FFFDFE' : '#B1B1B1' }}
      >
        {lastMessageTime}
      </div>
      {!isReadedLastMessage && !isSelected && (<div className='chat-red-dot' />)}
    </div>
  );
};

export default ChatItem;
